// extracted by mini-css-extract-plugin
export default {"sort":"KW-z","sortSelect":"LW-z","disabled":"MW-z"};